import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import { Globe } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const languages = [
  { code: 'en', lang: 'English' },
  { code: 'es', lang: 'Español' },
];

const LanguageSelector = ({ type }) => {
  const { i18n } = useTranslation();
  const [selectedLanguage, setSelectedLanguage] = useState(i18n.language);

  const changeLanguage = (langCode) => {
    i18n.changeLanguage(langCode);
    setSelectedLanguage(i18n.language);
  };

  const selectorDropdown = () => {
    return (
      <Menu as="div" className="relative inline-block text-left">
        <div>
          <MenuButton className="w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-purple-100 ease-in-out duration-500">
            <Globe aria-hidden="true" className="size-5 text-gray-700" />
          </MenuButton>
        </div>

        <MenuItems
          transition
          className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-75 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-150 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
        >
          <div className="py-1 max-h-36 overflow-y-auto languageDropdownScroller">
            {languages.map((item) => {
              return (
                <MenuItem key={item.code}>
                  <span
                    className={`block px-4 py-2 text-sm text-gray-700 cursor-pointer ${
                      selectedLanguage === item.code
                        ? 'bg-veryLightPurple text-white'
                        : 'hover:bg-gray-100 hover:text-gray-900 hover:outline-none'
                    }`}
                    onClick={() => changeLanguage(item.code)}
                  >
                    {item.lang}
                  </span>
                </MenuItem>
              );
            })}
          </div>
        </MenuItems>
      </Menu>
    );
  };

  return selectorDropdown();
};

export default LanguageSelector;
